import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { IServerErrorResponse } from '../../../types';
import bugsnagHandler from '../../../services/bugsnag.service';
import { TRANSFER_TYPES } from '../steps/Review';
import { endpointManager } from '../../../services/endpoint.service';

export interface IAchOutFee {
  achTransferType: TRANSFER_TYPES;
  arrivalDate: string;
  arrivalDateShort: string;
  fee: number;
}

export interface IAchOutFees {
  expirationDate: Date;
  feeDescription: string;
  fees: [IAchOutFee];
}

interface IProps {
  customerId: string;
  amount: string;
  onSuccess?: (data: IAchOutFees) => void;
}

export const getAchOutFees = ({ customerId, amount, onSuccess }: IProps) => {
  const { getAchOutFeesUrl } = endpointManager();
  return useQuery(
    'ach-out-fees',
    async () => {
      const { data } = await httpService.get(
        getAchOutFeesUrl(amount),
      );
      return data;
    },
    {
      enabled: false,
      cacheTime: 10,
      onSuccess: (data: IAchOutFees) => {
        if (onSuccess) onSuccess(data);
      },
      onError: (data: IServerErrorResponse) => {
        bugsnagHandler.notify(
          `Failed to fetch ach out fees for customerId: ${customerId} with the error: ${data?.response?.data?.errors?.[0]?.message || ''}`,
        );
      },
    },
  );
};
